import { AppRouteProps } from "@harea/component";
import React from "react";

const PrimeListContainer = React.lazy(() => import("./container/PrimeListContainer"));

export const PrimeRoutes = [
    {
        path: "primes",
        element: <PrimeListContainer />,
        title: "std_prime",
    },
] as Array<AppRouteProps>;
